import { defineMessages } from 'react-intl';
export const mapSwitcherMessages = defineMessages({
    opacitySlider: {
        id: 'mapSwitcher.opacitySlider',
        defaultMessage: 'Změnit průhlednost vrstvy',
    },
});
//# sourceMappingURL=mapSwitcherMessages.js.map